import styles from "./index.module.scss";
import classNames from "classnames";
import intl from "react-intl-universal";
import { Button, Carousel } from "antd";
import { useNavigate } from "react-router-dom";

const Panel = () => {
  const navigate = useNavigate();
  const goLink = (url) => {
    navigate("/about/" + url);
  };

  return (
    <div className={styles.hero}>
      {/* 首页轮播图 */}
      <Carousel autoplay autoplaySpeed={3600} arrows infinite className={styles.carousel}>
        {/* OpenGA 介绍 */}
        <div className={classNames(styles.panelBox, styles.openGaPanel)}>
          <div className={classNames("container", styles.midleBox)}>
            <h1>{intl.get("Header.OpenGA")}</h1>
            {intl.get("Home.OpenGA introduction").split("\n\n").map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <div>
              <Button size="large" ghost onClick={() => {
                navigate("/about/openga");
                window.scrollTo(0, 0);
              }}>
                {intl.get("Home.Learn more about OpenGA")}
              </Button>
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  navigate("/infrastructure/openGA");
                  window.scrollTo(0, 0);
                }}
              >
                {intl.get("Home.Try OpenGA")}
              </Button>
            </div>
          </div>
        </div>
        {/* OGA 介绍 */}
        <div className={styles.panelBox}>
          <div className={classNames("container", styles.midleBox)}>
            <h1>{intl.get("Home.Open Geospatial Engine Alliance")}</h1>
            <p>{intl.get("Geospatial Freedom, Global Progress.")}</p>
            <p>{intl.get("For a More Open, Connected,")}</p>
            <p>{intl.get("and Collaborative Geospatial Future")}</p>
            <div>
              <Button size="large" ghost onClick={() => goLink("who-we-are")}>
                {intl.get("Home.LEARN MORE")}
              </Button>
              <Button size="large" type="primary" onClick={() => navigate("/about/contact-us")}>
                {intl.get("Header.Contact Us")}
              </Button>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};
export default Panel;
